import React, { Component } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { insertHtml } from "../../utils/dom";
import { escapeRegExp, fixProfessorName } from "../../utils/utils";
import "./professor_component.scss";

const DEFAULT_PROFESSOR_IMAGE = "/professor_profile.png";
let keywordArray: any = [];
let keyword2: any = [];
let areaArray: any = [];
let areaPerProfessor: any = [];

interface ProfessorTeaching {
    title: string;
    url: string;
}

export interface ProfessorData {
    name: string;
    surname: string;
    type: string;
    image_url?: string;
    cv_url?: string;
    homepage?: string;
    email?: string;
    keywords: [];
    areas: [];
    matricola: string;
    parole_chiave?: string;
    centri_ricerca?: string[];

    teachings: { [key: string]: ProfessorTeaching[] };

    department?: string;
    university?: string;
}

export function professorFilter(professor: ProfessorData): any {
    return `${professor.parole_chiave}`;
}

// we take the data from scholars component. this way we can take an array with all the keywords 
// for each professor.
export function getKeyword(data: any) {
    keywordArray = data.map((i: any) => ({
        name: i.name + " " + i.surname,
        keyword: i.keywords.map((j: any) => ({
            keyword: j.keyword,
        }))
    }));
}

// same as above, we take the data from scholars component. this time we want only 
// the areaOfTeaching and the name of the professor.
export function getArea(data: any) {
    areaArray = data.map((i: any) => ({
        name: i.name + " " + i.surname,
        areaOfTeaching: i.areas.map((j: any) => ({
            area: j.area,
            id: j["ID"],
        }))
    }));
}

export function professorKey(professor: ProfessorData): string {
    return `${professor.surname}-${professor.name}-${professor.email}`;
}

export function orderProfessors(data: ProfessorData[]): ProfessorData[] {
    return data.sort((profA, profB) => {
        return `${profA.surname} ${profA.name}`.localeCompare(`${profB.surname} ${profB.name}`);
    })
}

interface ProfessorComponentData extends ProfessorData {
    fullview?: boolean;
    highlight?: string;
    mini?: boolean;
    lang?: string;
    valueKey?: string;
}

class ProfessorComponent extends Component<ProfessorComponentData> {

    constructor(props: Readonly<ProfessorComponentData>) {
        super(props);

    }

    render() {
        const prof = this.props;
        const profName = `${prof.name} ${prof.surname}`;
        const profUrl = prof.cv_url ? prof.cv_url : prof.homepage;
        const key = professorKey(prof);

        const selectedKeyWord: any = this.props.valueKey && this.props.keywords ? this.props.keywords[+this.props.valueKey - 1] : '';
        // here we grab the keywords for each professor (one at a time). Although since not all professors
        // have "parole_chiave" property, we need to take the rest from line 43.
        const keyword = professorFilter(prof);

        // if the keyword of the professor is undefined we need to get the keywords from line 43.
        // we also need to check the professors name to be the correct, because the keywordArray has
        // many professor's keywords.
        if (keyword === "undefined") {
            keywordArray.map((i: any) => {
                if (profName === i.name) {
                    keyword2 = i.keyword;
                }
            });
        }
        // we check the professor's name and then take the respective areaOfTeaching for the professor.
        areaArray.map((i: any) => {
            if (profName === i.name) {
                areaPerProfessor = i.areaOfTeaching;
            }
        });

        // if (this.props.fullview && prof.keywords) {

        //     this.props.keywords
        //         .split(" ")
        //         .map(word => word.replace(/\W/g, ''))
        //         .forEach(highlight => {
        //             console.log(highlight);
        //             let highlightRegex = new RegExp("(" + escapeRegExp(highlight) + ")", "gi");
        //             keywords = keywords!.replace(highlightRegex, "<span class='underlined'>$1</span>");
        //         });

        // }

        return (
            <Container fluid={true} className={"h-professor h-card professor-component " + (this.props.mini ? "mini" : "")} key={professorKey(prof)}>
                <Row>
                    <Col xs={this.props.mini ? 4 : 5} className="photo-col" key={`prof-photo-col-${key}`}>
                        {profUrl ?
                            // <a href={profUrl} key={`prof-photo-url-${key}`}>
                            <img className="u-photo" alt={profName} key={`prof-photo-u-${key}`}
                                src={prof.image_url ? prof.image_url : DEFAULT_PROFESSOR_IMAGE} />
                            // </a>
                            :
                            <img className="u-photo" alt={profName} key={`prof-photo-${key}`}
                                src={prof.image_url ? prof.image_url : DEFAULT_PROFESSOR_IMAGE} />
                        }
                    </Col>
                    <Col xs={this.props.mini ? 8 : 7} className="info-col" key={`prof-info-col-${key}`}>
                        <div className="p-name" key={`prof-name-${key}`}>
                            {/*{profUrl ? <a href={profUrl} title={"Visita il profilo di " + profName}>{profName}</a> : profName}*/}
                            {fixProfessorName(profName)}
                        </div>
                        <div className="p-role" key={`prof-role-${key}`}>
                            {prof.type}
                        </div>
                        <div className="p-university" key={`prof-university-${key}`}>
                            {prof.university}
                        </div>
                        {prof.email &&
                            <a className="u-email" href={`mailto:${prof.email}`} key={`prof-email-${key}`}>{prof.email}</a>
                        }
                        {areaPerProfessor.length === 0 ?
                            null :
                            <p className="key-terms">
                                <span className="key-label">{(this.props.lang === "it") ? "Area di competenza:" : "Research Areas:"}</span>
                                <span>{areaPerProfessor.map((i: any) =>
                                    (" " + i.area)).toString()}</span>
                            </p>
                        }
                        {keyword !== "undefined" ?
                            <p className="key-terms">
                                <span className="key-label">{(this.props.lang === "it") ? "Parole chiave della ricerca:" : "Keywords:"}</span>
                                <span>{keyword}</span>
                            </p> : keyword2.length === 0 ?
                                null :
                                <p className="key-terms">
                                    <span className="key-label">{(this.props.lang === "it") ? "Parole chiave della ricerca:" : "Keywords:"}</span>
                                    <span>{keyword2.map((i: any) =>
                                        (" " + i.keyword)).toString()}</span>
                                </p>
                        }


                        {/* PROF'S DEPARTMENTS & AREA DETAIL */}
                        {/* {this.props.fullview ?
                            prof.teachings ?
                                Object.keys(prof.teachings).map((department, index) => {

                                    const teachings = prof.teachings[department];

                                    return (
                                        <span key={`prof-department-c-${key}-${index}`}>
                                            <div className="p-department p-org" key={`prof-department-${key}-${index}`}>{department}</div>
                                            {teachings && teachings.length && teachings.map((teaching, index2) =>
                                                <a href={teaching.url} key={`prof-teaching-${key}-${index}-${index2}`} className="u-teaching">{teaching.title}</a>
                                            )}
                                        </span>
                                    );
                                })
                                :
                                (prof.department &&
                                    <span key={`prof-department-c-${key}`}>
                                        <div className="p-department p-org" key={`prof-department-${key}`}>{prof.department}</div>
                                    </span>
                                )
                            : ''
                        }
                        {this.props.fullview && prof.centri_ricerca &&
                            <p className="research-centers"><span className="research-label">Centri di ricerca:</span> <br />
                                {prof.centri_ricerca.map(center =>
                                    <span className="research-center">{center}</span>
                                )}
                            </p>
                        } */}
                        {prof.matricola &&
                            <a className="u-url homepage" href={"/faculty/"+prof.matricola} key={`prof-homepage-${key}`}>{(this.props.lang === "it") ? "Vedi il profilo" : "View Profile"}</a>
                        }
                        
                        {/*{prof.homepage && <a className="u-url homepage" href={prof.homepage} key={`prof-homepage-${key}`}>{(this.props.lang === "it") ? "Vedi il profilo" : "View Profile"}</a>}
                         */}</Col>
                </Row>
            </Container>
        );
    }
}

export default ProfessorComponent;